"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var endOfToday = function endOfToday() {
    var actualDate = new Date();
    var endOfDayDate = new Date(actualDate.getFullYear(), actualDate.getMonth(), actualDate.getDate(), 23, 59, 59, 999);

    return endOfDayDate.getTime();
};

var uniqueOfArray = function uniqueOfArray(array) {
    // 临时数组
    var n = [];
    for (var i = 0; i < array.length; i++) {
        if (n.indexOf(array[i]) === -1) {
            n.push(array[i]);
        }
    }
    return n;
};

exports.endOfToday = endOfToday;
exports.uniqueOfArray = uniqueOfArray;